const Cropper = ({
  isShow,
  isAddedImage,
  cropWidth,
  cropHeight,
  cropIsSaveProportions,
  cropError,
  cropInputChangeHandler,
  cropInputWidth,
  cropInputHeight,
  cropIsSaveProportionsHandler
}: {
  isShow: boolean;
  isAddedImage: boolean;
  cropWidth: number;
  cropHeight: number;
  cropIsSaveProportions: boolean;
  cropError: {
    isValid: boolean;
    type: string;
    input: string;
    description: string;
  };
  cropInputChangeHandler: Function;
  cropInputWidth: any,
  cropInputHeight: any,
  cropIsSaveProportionsHandler: Function;
}): JSX.Element => {
  if (!isShow) return <></>;

  const widthError = cropError && cropError.input === "width" 
    ? ( <span className="warning-text">{cropError.description}</span>) 
    : (<></>)

  const heightError = cropError && cropError.input === "height" 
  ? ( <span className="warning-text">{cropError.description}</span>) 
  : (<></>)

  return (
    <form className="service__control-form form">
      <div className="form__group">
        <label>
          <span>Width, px</span>
          <input type="text" id="width-value"value={+cropWidth} disabled={!isAddedImage} ref={cropInputWidth} onChange={() => cropInputChangeHandler()} />
          {widthError}
        </label>
        <button type="button" disabled={!isAddedImage} onClick={() => cropIsSaveProportionsHandler(cropIsSaveProportions)}>
          <i className={cropIsSaveProportions ? "icon__lock" : "icon__un-lock"}/>
        </button>
        <label>
          <span>Height, px</span>
          <input type="text" id="height-value" value={+cropHeight} disabled={!isAddedImage} ref={cropInputHeight} onChange={() => cropInputChangeHandler()}/>
          {heightError}
        </label>
      </div>
    </form>
  );
};

export default Cropper;
